import React, { useState, useEffect, useRef } from 'react';
import { X, Check } from 'lucide-react';

const EditableText = ({ text, maxLength, onSave, onCancel, isTextArea = false, label, isCompleted = false, color }) => {
    const [isEditing, setIsEditing] = useState(text === '');
    const [tempText, setTempText] = useState(text);
    const inputRef = useRef(null);
  
    useEffect(() => {
      if (isEditing && inputRef.current) {
        inputRef.current.focus();
      }
    }, [isEditing]);
  
    const handleEditStart = () => {
      setIsEditing(true);
      setTempText(text);
    };
  
    const handleEditSave = () => {
      onSave(tempText);
      setIsEditing(false);
      if (tempText === '') {
        setIsEditing(true);
      }
    };
  
    const handleEditCancel = () => {
      setTempText(text);
      setIsEditing(false);
      if (text === '') {
        setIsEditing(true);
      }
      onCancel();
    };
  
    const handleKeyDown = (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        handleEditSave();
      } else if (e.key === 'Escape') {
        handleEditCancel();
      }
    };
  
    return (
      <div className="relative w-full">
        {isEditing ? (
          <div className="relative pt-4 pb-6">
            <label className={`absolute text-xs text-gray-500 ${color} px-1 top-2 left-2`}>
              {label}
            </label>
            {isTextArea ? (
              <textarea
                ref={inputRef}
                value={tempText}
                onChange={(e) => setTempText(e.target.value.slice(0, maxLength))}
                onKeyDown={handleKeyDown}
                className="w-full bg-transparent border border-gray-400 focus:outline-none focus:border-blue-500 px-2 py-1 rounded resize-none"
                maxLength={maxLength}
                rows={2}
              />
            ) : (
              <input
                ref={inputRef}
                type="text"
                value={tempText}
                onChange={(e) => setTempText(e.target.value.slice(0, maxLength))}
                onKeyDown={handleKeyDown}
                className="w-full bg-transparent border border-gray-400 focus:outline-none focus:border-blue-500 px-2 py-1 rounded"
                maxLength={maxLength}
              />
            )}
            <div className="absolute right-0 bottom-0 flex items-center space-x-2 text-xs">
              <span className="text-gray-500">
                {tempText.length}/{maxLength}
              </span>
              <button onClick={handleEditCancel} className="text-red-500 hover:text-red-700">
                <X size={14} />
              </button>
              <button onClick={handleEditSave} className="text-green-500 hover:text-green-700">
                <Check size={14} />
              </button>
            </div>
          </div>
        ) : (
          <div
            onClick={handleEditStart}
            className={`cursor-text break-words ${isTextArea ? 'whitespace-pre-wrap' : 'truncate'} ${isCompleted ? 'text-gray-500 line-through' : ''
              }`}
          >
            {text || <span className="text-gray-400 italic">Click to edit</span>}
          </div>
        )}
      </div>
    );
  };

  export default EditableText;